import { ChatPage } from "@pages/ChatPage";
import { CenteredLoadingSpinner } from "@shared/components/CenteredLoadingSpinner";
import { useIsCrmEnabled } from "@shared/access-control/useIsCrmEnabled";

export function NewChatEntry() {
  const isCrmEnabled = useIsCrmEnabled();

  if (isCrmEnabled === null) {
    return <CenteredLoadingSpinner />;
  }

  return <ChatPage view={isCrmEnabled ? "focus" : "chat"} />;
}
